module.exports = __webpack_public_path__ + "static/profhilo-before-6a8b8c77b95ed89a71b5fa6217317e25.jpg";